// deps
import { defineMessage } from "react-intl";

// Civilité

/** Non défini */
export const USER_GENDER_VALUE_UN = "Un";
/** Monsieur */
export const USER_GENDER_VALUE_MR = "Mr";
/** Madame */
export const USER_GENDER_VALUE_MRS = "Mrs";
/** Monsieur et madame */
export const USER_GENDER_VALUE_MMS = "Mms";

export const USER_GENDERS = {
  [USER_GENDER_VALUE_MR]: {
    id: USER_GENDER_VALUE_MR,
    label: "M.",
    labelLong: "Monsieur",
  },
  [USER_GENDER_VALUE_MRS]: {
    id: USER_GENDER_VALUE_MRS,
    label: "Mme.",
    labelLong: "Madame",
  },
  [USER_GENDER_VALUE_MMS]: {
    id: USER_GENDER_VALUE_MMS,
    label: "M. et Mme.",
    labelLong: "Monsieur et Madame",
  },
  [USER_GENDER_VALUE_UN]: {
    id: USER_GENDER_VALUE_UN,
    label: "",
  },
};

export const USER_GENDER_INTL_MESSAGES = {
  byValue: {
    [USER_GENDER_VALUE_UN]: {
      label: defineMessage({
        defaultMessage: "non défini",
        description: "civilité",
      }),
    },
    [USER_GENDER_VALUE_MR]: {
      label: defineMessage({
        defaultMessage: "monsieur",
        description: "civilité",
      }),
    },
    [USER_GENDER_VALUE_MRS]: {
      label: defineMessage({
        defaultMessage: "madame",
        description: "civilité",
      }),
    },
    [USER_GENDER_VALUE_MMS]: {
      label: defineMessage({
        defaultMessage: "monsieur et madame",
        description: "civilité",
      }),
    },
  },
};

export const USER_GENDER_LIST = Object.values(USER_GENDERS);

// Langues
/** Français */
export const USER_LOCALE_VALUE_FR = "fr";
/** Anglais */
export const USER_LOCALE_VALUE_EN = "en";
/** Italien */
export const USER_LOCALE_VALUE_IT = "it";
/** Espagnol */
export const USER_LOCALE_VALUE_ES = "es";
/** Portugais */
export const USER_LOCALE_VALUE_PT = "pt";
/** Allemand */
export const USER_LOCALE_VALUE_DE = "de";
/** Chinois */
export const USER_LOCALE_VALUE_ZH = "zh";
/** Polonais */
export const USER_LOCALE_VALUE_PL = "pl";
/** Néerlandais */
export const USER_LOCALE_VALUE_NL = "nl";
/** Japonais */
export const USER_LOCALE_VALUE_JP = "jp";
/** Russe */
export const USER_LOCALE_VALUE_RU = "ru";
/** Grec */
export const USER_LOCALE_VALUE_GR = "gr";
/** Arabe */
export const USER_LOCALE_VALUE_AE = "ae";

/** @type {Record<import("../types/alfred/UserCustomer").UserCustomerLanguage, { id: import("../types/alfred/UserCustomer").UserCustomerLanguage, label: string, flag: string, iso: string }>} */
export const USER_LOCALES = {
  [USER_LOCALE_VALUE_FR]: {
    id: USER_LOCALE_VALUE_FR,
    label: "Français",
    flag: "🇫🇷",
    iso: "FR",
  },
  [USER_LOCALE_VALUE_EN]: {
    id: USER_LOCALE_VALUE_EN,
    label: "Anglais",
    flag: "🇬🇧",
    iso: "GB",
  },
  [USER_LOCALE_VALUE_IT]: {
    id: USER_LOCALE_VALUE_IT,
    label: "Italien",
    flag: "🇮🇹",
    iso: "IT",
  },
  [USER_LOCALE_VALUE_ES]: {
    id: USER_LOCALE_VALUE_ES,
    label: "Espagnol",
    flag: "🇪🇸",
    iso: "ES",
  },
  [USER_LOCALE_VALUE_PT]: {
    id: USER_LOCALE_VALUE_PT,
    label: "Portugais",
    flag: "🇵🇹",
    iso: "PT",
  },
  [USER_LOCALE_VALUE_DE]: {
    id: USER_LOCALE_VALUE_DE,
    label: "Allemand",
    flag: "🇩🇪",
    iso: "DE",
  },
  [USER_LOCALE_VALUE_ZH]: {
    id: USER_LOCALE_VALUE_ZH,
    label: "Chinois",
    flag: "🇨🇳",
    iso: "CN",
  },
  [USER_LOCALE_VALUE_PL]: {
    id: USER_LOCALE_VALUE_PL,
    label: "Polonais",
    flag: "🇵🇱",
    iso: "PL",
  },
  [USER_LOCALE_VALUE_NL]: {
    id: USER_LOCALE_VALUE_NL,
    label: "Néerlandais",
    flag: "🇳🇱",
    iso: "NL",
  },
  [USER_LOCALE_VALUE_JP]: {
    id: USER_LOCALE_VALUE_JP,
    label: "Japonais",
    flag: "🇯🇵",
    iso: "JP",
  },
  [USER_LOCALE_VALUE_RU]: {
    id: USER_LOCALE_VALUE_RU,
    label: "Russe",
    flag: "🇷🇺",
    iso: "RU",
  },
  [USER_LOCALE_VALUE_GR]: {
    id: USER_LOCALE_VALUE_GR,
    label: "Grec",
    flag: "🇬🇷",
    iso: "GR",
  },
  [USER_LOCALE_VALUE_AE]: {
    id: USER_LOCALE_VALUE_AE,
    label: "Arabe",
    flag: "🇦🇪",
    iso: "AE",
  },
};

/** @type {{ byValue: Record<import("../types/alfred/UserCustomer").UserCustomerLanguage, { label: import("react-intl").MessageDescriptor }>} }} */
export const USER_LOCALE_INTL_MESSAGES = {
  byValue: {
    [USER_LOCALE_VALUE_FR]: {
      label: defineMessage({
        defaultMessage: "français",
        description: "langue parlée par le client",
      }),
    },
    [USER_LOCALE_VALUE_EN]: {
      label: defineMessage({
        defaultMessage: "anglais",
        description: "langue parlée par le client",
      }),
    },
    [USER_LOCALE_VALUE_IT]: {
      label: defineMessage({
        defaultMessage: "italien",
        description: "langue parlée par le client",
      }),
    },
    [USER_LOCALE_VALUE_ES]: {
      label: defineMessage({
        defaultMessage: "espagnol",
        description: "langue parlée par le client",
      }),
    },
    [USER_LOCALE_VALUE_PT]: {
      label: defineMessage({
        defaultMessage: "portugais",
        description: "langue parlée par le client",
      }),
    },
    [USER_LOCALE_VALUE_DE]: {
      label: defineMessage({
        defaultMessage: "allemand",
        description: "langue parlée par le client",
      }),
    },
    [USER_LOCALE_VALUE_ZH]: {
      label: defineMessage({
        defaultMessage: "chinois",
        description: "langue parlée par le client",
      }),
    },
    [USER_LOCALE_VALUE_PL]: {
      label: defineMessage({
        defaultMessage: "polonais",
        description: "langue parlée par le client",
      }),
    },
    [USER_LOCALE_VALUE_NL]: {
      label: defineMessage({
        defaultMessage: "néerlandais",
        description: "langue parlée par le client",
      }),
    },
    [USER_LOCALE_VALUE_JP]: {
      label: defineMessage({
        defaultMessage: "japonais",
        description: "langue parlée par le client",
      }),
    },
    [USER_LOCALE_VALUE_RU]: {
      label: defineMessage({
        defaultMessage: "russe",
        description: "langue parlée par le client",
      }),
    },
    [USER_LOCALE_VALUE_GR]: {
      label: defineMessage({
        defaultMessage: "grec",
        description: "langue parlée par le client",
      }),
    },
    [USER_LOCALE_VALUE_AE]: {
      label: defineMessage({
        defaultMessage: "arabe",
        description: "langue parlée par le client",
      }),
    },
  },
};

export const USER_LOCALE_LIST = Object.values(USER_LOCALES);

// Classification des comptes

/** Compte client */
export const USER_CLASS_VALUE_CUSTOMER = "Customer";
/** Agent */
export const USER_CLASS_VALUE_AGENT = "Agent";
/** Partenaire */
export const USER_CLASS_VALUE_PARTNER = "Partner";

export const USER_CLASSES = {
  [USER_CLASS_VALUE_CUSTOMER]: {
    id: USER_CLASS_VALUE_CUSTOMER,
    label: "client",
    bookingAutocompleteLabel: "propriétaire",
    faIcon: "fa-user",
  },
  [USER_CLASS_VALUE_AGENT]: {
    id: USER_CLASS_VALUE_AGENT,
    label: "agent",
    bookingAutocompleteLabel: "agent",
    faIcon: "fa-users",
  },
  [USER_CLASS_VALUE_PARTNER]: {
    id: USER_CLASS_VALUE_PARTNER,
    label: "partenaire",
    bookingAutocompleteLabel: "partenaire",
    faIcon: "fa-handshake-o",
  },
};

export const USER_CLASS_LIST = Object.values(USER_CLASSES);
